<template>
  <v-container fluid>
    <v-toolbar class="mb-4">
      <v-toolbar-title>Instances
        <v-btn icon small  color="info" :to="{ name: 'instances-form', params: { instance_id: 0 }}"><v-icon size="18">add</v-icon></v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <v-data-table :headers="headers" :loading="inProgress" :pagination.sync="pagination" :total-items="pagination.totalItems" :items="items">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-right ">
              <div class="table_actions_btns">
                <v-btn icon small :to="{ name: 'instances-form', params: { instance_id: props.item.id }}" color="success" :ripple="false"><v-icon size="18">edit</v-icon></v-btn>
                <remove-dialog :yes="() => remove(props.item)">
                  <v-btn color="error" icon small :ripple="false"><v-icon size="18">delete_forever</v-icon></v-btn>
                </remove-dialog>
              </div>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  import * as mixins from '@/mixins/'

  export default {
    name: 'InstancesListPage',
    mixins: [mixins.removable, mixins.table, mixins.preloader, mixins.user],
    data() {
      return {
        api: this.$api.instances,
        headers: [
          { text: 'Name', align: 'left', sortable: true, value: 'firstname' },
          { text: 'Action', align: 'right', sortable: false },
        ],
      }
    },
  }
</script>
